// extracted by mini-css-extract-plugin
module.exports = {"gold":"RankingMedalIcon_gold__1qkKl","silver":"RankingMedalIcon_silver__H5Cph","bronze":"RankingMedalIcon_bronze__5RTkJ"};